<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-app-bar-title>{{ $t('appName') }}</v-app-bar-title>
      <v-spacer></v-spacer>
      <nav-buttons v-if="isLoggedIn" mode="normal" />
      <v-btn v-if="isLoggedIn" text @click="logout">
        {{ $t('logout') }}
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>

    <v-footer app>
      <v-spacer></v-spacer>
      <v-btn-toggle v-model="currentLanguage" mandatory>
        <v-btn value="en">
          English
        </v-btn>
        <v-btn value="zh">
          中文
        </v-btn>
      </v-btn-toggle>
    </v-footer>
  </v-app>
</template>

<script setup>
import { computed, ref, watch, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import { useI18n } from 'vue-i18n'
import NavButtons from '@/components/NavButtons.vue'

const router = useRouter()
const authStore = useAuthStore()
const { locale } = useI18n()

const isLoggedIn = computed(() => authStore.user !== null)

const logout = () => {
  authStore.logout()
  router.push('/login')
}

const currentLanguage = ref(locale.value)

watch(currentLanguage, (newLang) => {
  locale.value = newLang
})

onMounted(() => {
  // Check timezone and set default language
  const timezoneOffset = new Date().getTimezoneOffset()
  const isChineseTimezone = timezoneOffset === -480 // UTC+8
  currentLanguage.value = isChineseTimezone ? 'zh' : 'en'
})
</script>